//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'

//#endregion

//#region IMR Imports

import { IIMRPopup, IMRPopupOptions, IMRPopupHidingArgs } from '@imr/controls.angularjs/components/overlay/popup'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'

//#endregion

import { Activity, Enums } from '../../../../../../models/common'
import { ColumnInfo } from '../../../../../../models/custom'
import { ColumnModel } from '../../../../../api/api.models'
import { Dictionary, KeyType } from '../../../../../../helpers/dictionary'
import { IAlarmConfigurable, IReferenceType } from '../../../../../../models/util/interfaces'
import { OpAlarmGroup, OpAlarmType, OpDataType, OpView, OpViewColumn, OpMeter } from '../../../../../../models/core'

import { ConfigHelper, ConvertHelper, EventsNames, LocalizationHelper, LogHelper, TemplateHelper, ToastHelper, TypeHelper } from '../../../../../../helpers'
import { AlarmDefinitionService } from '../../../../../../services/alarm-definition'
import { GridService } from '../../../../../../services/grid'
import { PopupHelper } from '../../../../../../helpers/popup-helper'
import { ReferenceTypeService } from '../../../../../../services/reference-type'
import { UserSessionService } from '../../../../../../services/user-session'

import { IAlarmDefinitionsBulkEditOptions, GoAlarmDef } from '../../interfaces/alarm-definitions-edit.interfaces'
import { IAlarmDefinitionGroupRowEdit } from '../../../alarm-definition-group-row-edit/alarm-definition-group-row-edit.interfaces'
import { AlarmDefinitionItemEditOptions } from '../../../alarm-definition-item-edit/alarm-definition-item-edit.interfaces'
import { IAlarmDefinitionsParameters } from '../../../alarm-definitions-parameters/alarm-definitions-parameters.interfaces'
import { ActionStatusOptions } from '../../../../action-status/action-status.controller'
import { ConfirmationOptions } from '../../../../confirmation-popup/confirmation-popup.directive'
import { GridOptions, GridController, GridTypes } from '../../../../grid'
import { AlartDefinitionsEditCommonController } from '../alarm-definitions-edit-common/alarm-definitions-edit-common.controller'
import { SequentialItemSaver, SequentialItemSaverOptions, SequentialItemSaverProgress, SequentialItemSaverStatus, SequentialItemSaverResult } from '../../../../../../helpers/sequential-item-saver'

// #region AlarmDefinitionsEditScope

export interface IAlarmDefinitionsBulkEditScope
    extends ng.IScope { }

// #endregion

export class AlarmDefinitionsBulkEditController
    extends AlartDefinitionsEditCommonController
    implements ng.IComponentController {

    // #region Consts

    public get SAVING_SUMMARY_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SavingSummary) }
    private get ALARM_DEFINITIONS_REFERENCE_VALUES_GRID_NAME(): string { return 'alarmDefRefValuesGrid' }
    private get ERROR_INFO(): string { return 'errorInfo' }
    private get MASTER_DETAILS_TEMPLATE_NAME(): string { return 'errors' }

    // #endregion

    // #region Members

    //#region input parameters

    private options: IAlarmDefinitionsBulkEditOptions

    //#endregion

    public addAlarmGroupPopoverOptions: DevExpress.ui.dxPopoverOptions
    public alarmGroupsContainerScrollViewOptions: DevExpress.ui.dxScrollViewOptions
    public availableAlarmGroupsSelectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    public finishButtonOptions: DevExpress.ui.dxButtonOptions
    public id: number = new Date().getTime()
    public imrPopupOptions: IMRPopupOptions
    public isStarted: boolean
    public gridOptions: GridOptions
    public savingProgressOptions: DevExpress.ui.dxProgressBarOptions
    public sendObjectConfigurationOptions: DevExpress.ui.dxButtonOptions
    public startButtonOptions: DevExpress.ui.dxButtonOptions
    public stopButtonOptions: DevExpress.ui.dxButtonOptions
    public uploadedPercent: number

    private addAlarmGroupPopover: DevExpress.ui.dxPopup
    private alarmDefParams: IAlarmDefinitionsParameters
    private dataSource: IAlarmConfigurable
    private dxGrid: DevExpress.ui.dxDataGrid
    private gridController: GridController<IAlarmConfigurable>
    private gridData: any[] = []
    private imrPopup: IIMRPopup
    private isHidingCanceled: boolean
    private hasChanges: boolean
    private referenceObjectReferenceTypeName: string
    private saver: SequentialItemSaver<IAlarmConfigurable>
    private selectedNewAlarmGroup: OpAlarmGroup

    //#endregion

    // #region Ctor

    constructor(
        private $scope: IAlarmDefinitionsBulkEditScope,
        private userSessionService: UserSessionService,
        protected alarmDefinitionService: AlarmDefinitionService,
        private gridService: GridService,
        private referenceTypeService: ReferenceTypeService
    ) {
        super(alarmDefinitionService)

        this.setPopupOptions()
    }

    //#region Ctor


    //#endregion


    //#region IComponentController Implementation

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.showPopup()
            this.initialize()
        }
    }

    //#endregion

    // #endregion

    // #region IAlarmDefinitionsEdit

    private showPopup(): void {
        if (this.popupExists()) {
            this.imrPopup.show()
        } else {
            LogHelper.error(AlarmDefinitionService.LOG_PREFIX, `Can't show popup - popup doesn't exist`)
        }
    }

    private hidePopup(): void {
        if (this.popupExists()) {
            this.imrPopup.hide()
        } else {
            LogHelper.error(AlarmDefinitionService.LOG_PREFIX, `Can't hide popup - popup doesn't exist`)
        }
    }

    private setDataSource(dataSource: IAlarmConfigurable): void {
        if (dataSource == null) {
            return
        }

        this.dataSource = dataSource

        if (this.areAlarmDefParamsVisible()
            && TypeHelper.isIOpObject(<any>this.dataSource)
            && this.alarmDefParams != null
        ) {
            this.alarmDefParams.setDataSource(<any>this.dataSource)
        }

        this.setAlarmDefs(dataSource.currentAlarmDefs)
    }

    public showLoader(): void {
        this.imrPopup.toggleLoading(true)
    }

    public hideLoader(): void {
        this.imrPopup.toggleLoading(false)
    }

    // #endregion

    // #region Lifecycle    

    private hiding(e: any): void {
        if (this.isStarted == true) {
            e.cancel = true
            ToastHelper.showWarning(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CantClosePopupWhileSave))
            return
        }

        if (this.isSendConfigurationButtonVisible() && e != null && this.hasChanges && !this.isHidingCanceled) {
            e.cancel = true

            this.isHidingCanceled = true

            const confirmationOptions: ConfirmationOptions = {
                title: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendTheConfiugrationToThe)} ${this.referenceObjectReferenceTypeName}`,
                question: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefinitionsWereUpdatedToYouWantToSendConfiugrationTo)} ${this.referenceObjectReferenceTypeName}`,
                onConfirmed: () => {
                    this.sendConfiguration()
                    this.hidePopup()
                    this.onHidden()
                },
                onDeclined: () => {
                    this.hidePopup()
                    this.onHidden()
                },
            }

            this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.id, confirmationOptions)
        } else {
            this.hidePopup()
            this.onHidden()
        }
    }

    private initialize(): void {
        this.showLoader()

        this.initializeCommon()
        this.setCommonOptions()

        this.setFields()
        this.setOptions()

        this.setGridOptions()

        $.when(this.setDictionaries(), this.getTemplate())
            .then(() => {
                this.hideLoader()
            })
    }

    // #endregion

    // #region Events

    private onHidden(): void {
        this.alarmDefPopoverVisible = false
        this.gridOptions = null
        this.uploadedPercent = 0
        this.isStarted = false
        this.saver = null
    }

    private onSendObjectConfigurationClick(args: any): void {
        const confirmationOptions: ConfirmationOptions = {
            title: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendTheConfiugrationToThe)} ${this.referenceObjectReferenceTypeName}`,
            question: `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AreYouSureYouWantToSendConfiugrationTo)} ${this.referenceObjectReferenceTypeName}`,
            onConfirmed: () => { this.onSendObjectConfigurationConfirmed() },
            onDeclined: () => { },
        }

        this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.id, confirmationOptions)
    }

    private onSendObjectConfigurationConfirmed(): void {
        this.sendConfiguration()
            .then(() => {
                this.isSendToReferenceObjectEnabled = false
                ToastHelper.showSuccess()
            })
            .fail((error: any) => {
                const errorMessage: string = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMessage || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
            })
    }

    private onAlarmGroupPopoverAddAlarmGroupButtonClick(): void {
        this.alarmGroupsPossibleToAdd.splice(_.findIndex(this.alarmGroupsPossibleToAdd, (alarmGroup: OpAlarmGroup) => alarmGroup.idAlarmGroup === this.selectedNewAlarmGroup.idAlarmGroup), 1)

        this.addNewAlarmGroup(this.selectedNewAlarmGroup)

        this.addAlarmGroupPopover.toggle(false)
    }

    private onAvailableAlarmGroupsSelectBoxSelectionChanged(args: any): void {
        this.selectedNewAlarmGroup = args.selectedItem
    }

    private onAlarmConfigurableSaved(): void {
        if (this.optionsExists() && this.options.onAlarmConfigurableSaved != null) {
            this.options.onAlarmConfigurableSaved(this.dataSource)
        }
    }

    private onGridInitialized(gridController: GridController<IAlarmConfigurable>): void {
        this.gridController = gridController
        this.dxGrid = this.gridController.dxGrid
    }

    // #endregion

    // #region Setup    

    private setPopupOptions(): void {
        this.imrPopupOptions = {
            innerOptions: PopupHelper.mergeWithDefaultOptions({
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefinitionEdit),

                width: '100%',
                height: '100%',

                onHiding: (e: any) => { this.hiding(e) },
                onHidden: () => { this.isHidingCanceled = false },
            }),

            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.imrPopup = e.component
            }
        }
    }

    private setFields(): void {
        this.alarmDefPopoverVisible = false
        this.referenceObjectReferenceTypeName = LocalizationHelper.getLocalizedText(`To${Enums.SimaxModuleName[this.options.moduleName]}`)
    }

    private setOptions(): void {

        this.sendObjectConfigurationOptions = {
            template: TemplateHelper.getIconWithText(`${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationTo)} ${this.referenceObjectReferenceTypeName}`, ConfigHelper.Icon.DEVICES, this.userSessionService),
            bindingOptions: { disabled: '!$ctrl.isSendToReferenceObjectEnabled' },
            onClick: (args: any) => { this.onSendObjectConfigurationClick(args) }
        }

        this.startButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Start),
            bindingOptions: {
                disabled: '$ctrl.isStarted'
            },
            onClick: () => {
                this.startSaving()
            }
        }

        this.stopButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Stop),
            bindingOptions: {
                disabled: '!$ctrl.isStarted'
            },
            onClick: () => {
                this.stopSaving()
            }
        }

        this.finishButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Finish),
            bindingOptions: {
                disabled: '$ctrl.isStarted'
            },
            onClick: () => {
                this.finishSaving()
            }
        }

        this.uploadedPercent = 0

        this.savingProgressOptions = {
            visible: true,
            statusFormat: (ratio, value) => {
                return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Progress) + ': ' + Math.round(value) + '%'
            },
            bindingOptions: {
                value: '$ctrl.uploadedPercent'
            },
            value: 0,
            min: 0,
            max: 100
        }
    }

    private setDictionaries(): JQueryPromise<void> {
        const dataTypeGroupOptions: any = {
            skipView: true,
            groupReferenceType: Enums.ReferenceType.IdDistributor,
            groupReferenceValue: this.userSessionService.getLoggedOperator().idDistributor
        }

        const alarmGroupDeferred: JQueryDeferred<OpAlarmGroup[]> = $.Deferred<OpAlarmGroup[]>()

        const promises: JQueryPromise<any>[] = [
            this.gridService
                .getColumnModelByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__ALARM_DEF_PARAMS,
                    this.options.moduleName,
                    dataTypeGroupOptions
                ),
            this.gridService
                .getColumnModelByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__ALARM_DEF_REF_PARAMS,
                    this.options.moduleName,
                    dataTypeGroupOptions
                ),
            this.userSessionService
                .getDataProvider()
                .System
                .getDictionaries([Enums.ReferenceType.IdAlarmType, Enums.ReferenceType.IdDataType]),
            alarmGroupDeferred.promise()
        ]

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_GROUP_LIST)) {
            this.userSessionService
                .getDataProvider()
                .View
                .getActiveView(Enums.ReferenceType.IdAlarmGroup)
                .then((view: OpView) => {
                    if (view != null) {
                        const columns: ColumnInfo[] = []
                        const pkVColumn: OpViewColumn = view.getPrimaryKeyColumn()

                        const pkColumnInfo: ColumnInfo = new ColumnInfo(null)

                        pkColumnInfo.IdDataType = pkVColumn.idDataType
                        pkColumnInfo.Name = pkVColumn.name

                        columns.push(pkColumnInfo)

                        this.userSessionService
                            .getDataProvider()
                            .AlarmGroup
                            .getAlarmGroupFilter(columns, 1, TypeHelper.MAX_INT_VALUE, null)
                            .then((result: any) => {
                                const alarmGroups: OpAlarmGroup[] = result == null || result.objects == null
                                    ? null
                                    : result.objects.map((alarmGroup: any) => <OpAlarmGroup>alarmGroup)

                                alarmGroupDeferred.resolve(alarmGroups)
                            })
                    }
                })
        } else {
            alarmGroupDeferred.resolve(null)
        }

        return $.when<any>(
            ...promises
        )
            .then((alarmDefParams: ColumnModel[], alarmDefRefParams: ColumnModel[], dicts: Dictionary<Dictionary<IReferenceType>>, alarmGroups: OpAlarmGroup[]) => {
                this.alarmDefParamsColumns = alarmDefParams || []
                this.alarmDefRefParams = alarmDefRefParams || []

                this.alarmDefParamsExist = this.alarmDefParamsColumns.length > 0
                this.setAlarmDefTagBoxAcceptCustomValues(this.alarmDefParamsExist)

                this.alarmTypes = (
                    this.referenceTypeService.extractReferenceTypeDictionary(dicts, Enums.ReferenceType.IdAlarmType, (item: OpAlarmType) => item.idAlarmType)
                    || new Dictionary<OpAlarmType>(null, KeyType.Number)
                ).values()

                this.dataTypes = (
                    this.referenceTypeService.extractReferenceTypeDictionary(dicts, Enums.ReferenceType.IdDataType, (item: OpDataType) => item.idDataType)
                    || new Dictionary<OpDataType>(null, KeyType.Number)
                ).values()

                this.alarmGroups = alarmGroups || []
            })
    }

    private setGridOptions(): void {
        this.gridData = _.size(this.options.gridDataSource) > 0 ? this.options.gridDataSource : []
        if (this.gridController == null || this.gridController.dxGrid == null) {

            const defer: JQueryDeferred<ColumnModel[]> = $.Deferred<ColumnModel[]>()

            if (_.isFunction(this.options.getColumnsMethod)) {
                this.options
                    .getColumnsMethod()
                    .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                        defer.resolve(columns, defaultColumns)
                    })
            } else {
                $.when(
                    this.userSessionService
                        .getDataProvider().System
                        .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS, this.options.moduleName),
                    this.userSessionService
                        .getDataProvider().System
                        .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS, this.options.moduleName)
                ).then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                    defer.resolve(columns, defaultColumns)
                })
            }

            defer.promise()
                .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                    this.gridOptions = {
                        name: this.ALARM_DEFINITIONS_REFERENCE_VALUES_GRID_NAME,
                        columnsDictionary: columns,
                        defaultColumnsDictionary: defaultColumns,
                        dataSource: this.gridData,
                        referenceId: Enums.ReferenceType.IdMeter,
                        type: GridTypes.SMALL,
                        buttonsOptions: { enabled: true },
                        addCustomFilters: false,
                        masterDetail: {
                            enabled: true,
                            template: this.MASTER_DETAILS_TEMPLATE_NAME,
                            autoExpandAll: false
                        },
                        onInitialized: (e: any, grid: GridController<IAlarmConfigurable>) => this.onGridInitialized(grid),
                    }
                })
        } else {
            this.gridController.dxGrid.option({ dataSource: this.gridData })
        }
    }

    private getTemplate(): JQueryDeferred<void> {
        const defer: JQueryDeferred<void> = $.Deferred<void>()

        if (_.isFunction(this.options.getEentityRequestMethod) && _.size(this.options.gridDataSource) > 0) {
            this.options
                .getEentityRequestMethod(this.options.gridDataSource[0].id)
                .then((entity: IAlarmConfigurable) => {
                    this.setDataSource(entity)
                    defer.resolve(null)
                })
        } else {
            defer.resolve(null)
        }

        return defer
    }

    // #endregion

    // #region Flags   

    public areAlarmDefParamsVisible(): boolean {
        return !this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_DEF_EDIT_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.AlarmDefParams)
    }

    public isRegionFullSize(): boolean {
        return !this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_GROUP_LIST)
            || this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_DEF_EDIT_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.AlarmGroup)
    }

    public isSendConfigurationButtonVisible(): boolean {
        return this.optionsExists()
            && this.options.configurationReferenceObject != null
            && this.userSessionService.getLoggedOperator().hasPermission(this.options.sendConfigurationIdActivity)
    }

    public isGroupsEditVisible(): boolean {
        return this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_GROUP_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.ALARM_DEF_EDIT_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.AlarmGroup)
    }

    public isGroupEditVisible(options: AlarmDefinitionItemEditOptions): boolean {
        return this.alarmTypes != null
            && this.alarmTypes.length > 0
            && options != null
    }

    private popupExists(): boolean {
        return this.imrPopup != null
    }

    private optionsExists(): boolean {
        return this.options != null
    }

    // #endregion

    // #region AlarmDefinitionsEditController    

    private sendConfiguration(): JQueryPromise<ActionStatusOptions> {
        if (this.optionsExists()
            && this.options.sendConfiguration != null
            && this.options.configurationReferenceObject != null
        ) {
            return this.options.sendConfiguration(this.userSessionService.getDataProvider(), [this.options.configurationReferenceObject])
        }

        return $.Deferred<ActionStatusOptions>().resolve(null).promise()
    }

    private addNewAlarmGroup(alarmGroup: OpAlarmGroup): void {
        if (alarmGroup == null) { return }

        this.currentAlarmGroups.push(alarmGroup)

        if (this.alarmGroupEditControllers == null) {
            this.alarmGroupEditControllers = []
        }

        this.alarmGroupEditControllers.forEach((ctrl: IAlarmDefinitionGroupRowEdit) => {
            ctrl.repaint()
        })
    }

    private save(): void {
        const options: SequentialItemSaverOptions<IAlarmConfigurable> = {
            itemsToSave: this.gridData.map((data: any) => {
                const alarmObj: IAlarmConfigurable = new OpMeter(this.gridController.getSourceObject(data))
                alarmObj.currentAlarmDefs = this.currentAlarmDefs.map((alarmDef: GoAlarmDef) => alarmDef.toOpAlarmDef())
                return alarmObj
            }),
            saveDelegate: (toSave: IAlarmConfigurable) => this.saveEntity(toSave),
            progressDelegate: (progress: SequentialItemSaverProgress<IAlarmConfigurable>) => { this.onSaveProgress(progress) },
            finishedDelegate: (progress: SequentialItemSaverResult<IAlarmConfigurable>) => { this.onSaveFinish(progress) }
        }

        this.saver = new SequentialItemSaver<IAlarmConfigurable>(options)
        this.saver.start()
    }

    private onSaveProgress(progress: SequentialItemSaverProgress<IAlarmConfigurable>): void {
        this.calculateUpload(++progress.index)

        switch (progress.status) {
            case SequentialItemSaverStatus.Succes:
                this.gridData.forEach((data: any) => {
                    if (data.id === progress.sourceItem.getReferenceKey()) {
                        this.gridController.setItemDisplayState(data, { validation: Enums.ValidationStatus.Correct })
                        return
                    }
                })

                this.dxGrid.option({ dataSource: new DataSource(this.gridData) })
                break
            case SequentialItemSaverStatus.Error:
            case SequentialItemSaverStatus.Warning:
                const errorMsg: string = ConvertHelper.getRequestErrorMessage(progress.error)

                let index: number = -1
                this.gridData.forEach((data: any, _index: number) => {
                    if (data.id === progress.sourceItem.getReferenceKey()) {
                        data[this.ERROR_INFO] = errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator)
                        this.gridController.setItemDisplayState(data, { validation: Enums.ValidationStatus.Incorrect })
                        index = _index
                        return
                    }
                })
                this.dxGrid.option({ dataSource: new DataSource(this.gridData) })

                this.dxGrid.expandRow(this.gridData[index])
                break
        }
    }

    private onSaveFinish(progress: SequentialItemSaverResult<IAlarmConfigurable>): void {
        this.isStarted = false
    }

    private startSaving(): void {
        this.isStarted = true

        this.gridController.clearItemDisplayStates()

        this.save()
    }

    private stopSaving(): void {
        if (this.saver != null) {
            this.saver.cancel()
            this.isStarted = false
        }
    }

    private finishSaving(): void {
        this.hidePopup()
    }

    private saveEntity(objToSave: IAlarmConfigurable): JQueryPromise<IAlarmConfigurable> {
        return this.referenceTypeService
            .saveReferenceObject(objToSave)
            .then((referenceType: IReferenceType) => {
                return referenceType as IAlarmConfigurable
            })
    }

    private calculateUpload(index: number): void {
        if (this.gridData.length > 0) {
            this.uploadedPercent = (index / this.gridData.length) * 100
        }
    }

    // #endregion
}
